import React from 'react'

interface ExpandedDataPointNodeProps {
  data: {
    color: string
    selected?: boolean
    label?: string
    glowColor?: string
  }
}

const ExpandedDataPointNode: React.FC<ExpandedDataPointNodeProps> = ({ data }) => {
  return (
    <div
      style={{
        width: 10,
        height: 10,
        borderRadius: '50%',
        backgroundColor: data.color,
        border: data.selected ? '3px solid #fbbf24' : '2px solid rgba(255, 255, 255, 0.8)',
        cursor: 'pointer',
        boxShadow: data.selected
          ? '0 0 12px rgba(251, 191, 36, 0.8)'
          : `0 0 8px ${data.glowColor}80, 0 2px 4px rgba(0, 0, 0, 0.3)`,
        transition: 'all 0.2s ease',
        position: 'relative',
        zIndex: 10, // Higher z-index to appear above regular nodes
      }}
      title={`${data.label} (from cluster)`}
    >
      {/* Pulsing ring to indicate it's an expanded node */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: 14,
          height: 14,
          borderRadius: '50%',
          border: `1px solid ${data.glowColor}60`,
          animation: 'pulse 2s infinite',
          pointerEvents: 'none',
          transform: 'translate(-50%, -50%)',
        }}
      />
      {/* Selection ring for expanded nodes */}
      {data.selected && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: 12,
            height: 12,
            borderRadius: '50%',
            border: '2px solid #fbbf24',
            animation: 'pulse 1.5s infinite',
            pointerEvents: 'none',
            opacity: 0.8,
            transform: 'translate(-50%, -50%)',
          }}
        />
      )}
    </div>
  )
}

export default ExpandedDataPointNode
